import { render, staticRenderFns } from "./Pell.vue?vue&type=template&id=3bf30594"
import script from "./Pell.vue?vue&type=script&lang=js"
export * from "./Pell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports